/* global google */
import { createClient } from '@supabase/supabase-js'
import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer, GridAlgorithm } from "@googlemaps/markerclusterer";
import SimpleLightbox from "simplelightbox";
import moment from 'moment';

String.prototype.interpolate = function(params) {
	const names = Object.keys(params);
	const vals = Object.values(params);
	return new Function(...names, `return \`${this}\`;`)(...vals);
}

moment.updateLocale('en', {
	relativeTime: {
		future: "in %s",
		past: "%s ago",
		s: 'a few secs',
		ss: '%d secs',
		m: "1 min",
		mm: "%d mins",
		h: "1 hour",
		hh: "%d hours",
		d: "1 day",
		dd: "%d days",
		M: "1 month",
		MM: "%d months",
		y: "1 year",
		yy: "%d years"
	}
});

export class LiveMap extends HTMLElement {
	constructor() {
		super();

		this.supabase = createClient('https://mfszvmepvrddiqschjgc.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1mc3p2bWVwdnJkZGlxc2NoamdjIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODgxMjc0NTMsImV4cCI6MjAwMzcwMzQ1M30.4bYB2VapvhpsS_QDkT6jYTTqnhitF8GnaJk10CCwt4c')

		this.scrolled = false;

		this.routes = {};
		this.updates = {};
		this.paths = {};
		this.markers = {};
		this.markerexpanded = {};
		this.markercontents = {};
		this.storeIcons = JSON.parse(this.dataset.stores);
		this.vehicleIcons = JSON.parse(this.dataset.vehicles);

		console.log(this.vehicleIcons);

		this.storeMarkersVisible = false;

		this.storeMarkers = [];

		this.noresults = {
			title: this.dataset.noresultsTitle || '',
			message: this.dataset.noresultsMessage || '',
			ctaLink: this.dataset.noresultsCtaLink || '',
			ctaText: this.dataset.noresultsCtaText || '',
			redirect: this.dataset.noresultsRedirect || '',
		}

		this.finished = {
			title: this.dataset.finishedTitle || '',
			message: this.dataset.finishedMessage || '',
			ctaLink: this.dataset.finishedCtaLink || '',
			ctaText: this.dataset.finishedCtaText || '',
			redirect: this.dataset.finishedRedirect || '',
		}

		this.loadLocations().then(() => {

			this.loadMap().then(() => {

				const AdvancedMarkerElement = this.advancedMarkerElement;

				for (const user in this.routes){

					let last = this.routes[user][this.routes[user].length-1]

					if(last.meta.type == null || last.meta.type == 'null' || !last.meta.type){
						last.meta.type = 'Bike1';
					}

					if(last.meta.message == null || last.meta.message == 'null' || !last.meta.message){
						last.meta.message = '';
					}

					let pathStroke = '#79D0E3';

					if(last.meta.type == 'Bike1'){
						pathStroke = '#E0912A';
					}else if(last.meta.type == 'Bike2'){
						pathStroke = '#80C587';
					}

					last.heading = 'east';

					if(parseInt(last.meta.heading) > 180){
						last.heading = 'west';
					}

					if(!['BottleCan', 'Van1', 'Van2'].includes(last.meta.type)){

						this.paths[user] = new google.maps.Polyline({
							map: this.map,
							geodesic: true,
							path: this.routes[user].map((point) => { return { lat: parseFloat(point.latitude), lng: parseFloat(point.longitude) } }),
							strokeColor: pathStroke,
							strokeWeight: 5
						});

					}

					// console.log(last);

					let markertemplate = document.getElementById('live-map-marker') ? document.getElementById('live-map-marker').innerHTML : false;

					// console.log(markertemplate);

					let timer = moment(last.created_at);
					let fiveminutes = moment().subtract(5, 'minutes').toDate().getTime();
					// let fifteenminutes = moment().subtract(15, 'minutes').toDate().getTime();
					let time, timeclass = '';
					if(timer.toDate().getTime() > fiveminutes){
						time = 'LIVE'
						timeclass ='time-live'
					}else{
						time = moment(last.created_at).fromNow();
						timeclass ='time-notlive'
					}

					this.markerexpanded[user] = false;

					this.markercontents[user] = document.createElement('div');
					this.markercontents[user].className = "location-marker";
					this.markercontents[user].dataset.user = user;
					this.markercontents[user].innerHTML = markertemplate.interpolate({ marker: last, icons: this.vehicleIcons, time, timeclass });

					this.markers[user] = new AdvancedMarkerElement({
						position: new google.maps.LatLng(parseFloat(last.latitude), parseFloat(last.longitude)),
						map: this.map,
						content: this.markercontents[user],
						zIndex:200,
						// collisionBehavior: 'REQUIRED_AND_HIDES_OPTIONAL'
					});

					var _this = this;

					google.maps.event.addListener(this.markers[user], 'click', function(e){
						// window.open("https://www.google.com/maps/dir/?api=1&destination="+last.latitude+","+last.longitude, "_blank")
						console.log(e);
						var marker = e.domEvent.target.closest('.location-marker');
						var user = marker.dataset.user;
						console.log(marker);
						marker.classList.toggle('expanded');
						_this.markerexpanded[user] != _this.markerexpanded[user];
					});

					// this.map.setCenter({ lat: parseFloat(last.latitude), lng: parseFloat(last.longitude) });

				}

				// console.log('user updates');
				// console.log(this.updates);

				for (const user in this.updates){

					for(var ui = 0; ui < this.updates[user].length; ui++){

						this.addUpdateMarker(this.updates[user][ui].latitude, this.updates[user][ui].longitude, this.updates[user][ui].meta,  this.updates[user][ui].created_at);

					}

				}

				if(Object.keys(this.routes).length === 0){

					if(this.noresults.redirect.length > 0) {

						if (!Shopify.designMode) {
							window.location.href = this.noresults.redirect;
						}

					}else{

						let noresultstemplate = document.getElementById('live-map-no-results') ? document.getElementById('live-map-no-results').innerHTML : false;

						this.classList.add('no-results')
						let message = this.querySelector('#message')

						if(!message){
							message = document.createElement('div');
							message.id = 'message';
							this.prepend(message);
						}

						message.innerHTML = noresultstemplate.interpolate({ noresults: this.noresults });

						message.querySelector('.close').addEventListener('click', (e) => {
							e.preventDefault();
							this.classList.add('noresults-closed')
						})

					}

				}else{

					this.zoomToFit();
					this.checkForNewPoints();

					this.zoominterval = setInterval(this.zoomToFit.bind(this), 15000)
					this.checkinterval = setInterval(this.checkForNewPoints.bind(this), 15000)

					google.maps.event.addListener(this.map, 'click', () => { this.scrolled = true; } );
					google.maps.event.addListener(this.map, 'drag', () => { this.scrolled = true; } );
					google.maps.event.addListener(this.map, 'dragend', () => { this.scrolled = true; } );

					this.loadStores();

				}

			});

		});

	}

	loadMap(){

		return new Promise((resolve) => {
			const loader = new Loader({
				apiKey: "AIzaSyClaDL-gBqn6fAf90FHLxzi4g5GMS8eWhc"
			});

			loader.load().then(async () => {

				const { Map } = await google.maps.importLibrary("maps");
				const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

				this.map = new Map(this, {
					zoom: 6,
					mapId: "4a2133d0e14c7c08",
					center: new google.maps.LatLng(50.736129, -1.988229),
					fullscreenControl: false,
					mapTypeControl: false
				});

				this.advancedMarkerElement = AdvancedMarkerElement;

				resolve()

			});

		});

	}

	loadLocations(){

		return new Promise((resolve) => {

			const dateStart = new Date();
			dateStart.setUTCHours(0,0,0,0);
			const dateEnd = new Date();
			dateEnd.setUTCHours(23,59,59,999);

			this.supabase
				.from('location')
				.select('user,longitude,latitude,meta,created_at')
				.gt('created_at', dateStart.toISOString())
				.lt('created_at', dateEnd.toISOString())
				.order('created_at')
				.then(({data, error}) => {

					if(error){
						console.log('No data could be found', error);
					}else{
						// console.log(data);

						this.routes = data
						.filter((element) => {
							return !('update' in element.meta) || element.meta.update != true
						})
						.reduce((grouped, element) => ({
							...grouped,
							[element.user]: [...(grouped[element.user] || []), element]
						}), {})

						this.updates = data
						.filter((element) => {
							return 'update' in element.meta && element.meta.update
						})
						.reduce((grouped, element) => ({
							...grouped,
							[element.user]: [...(grouped[element.user] || []), element]
						}), {})

						this.latest = data[data.length-1]?.created_at || false;

						resolve();
					}

				});

		});

	}

	addUpdateMarker = async (lat, lng, meta, created_at) => {

		const AdvancedMarkerElement = this.advancedMarkerElement;

		// console.log(friendlyLocation, message, created_at);

		let updatetemplate = document.getElementById('live-map-update') ? document.getElementById('live-map-update').innerHTML : false;
		let updatephototemplate = document.getElementById('live-map-update-photo') ? document.getElementById('live-map-update-photo').innerHTML : false;

		let images = '';
		let hasImages = false;

		if(meta.images.length > 0){

			hasImages = true;

			images += '<div class="updateimages">';

			for(let i = 0; i < meta.images.length; i++){

				images += `<div class="updateimage clickableimage">
					<a class="clickableimage" href="https://mfszvmepvrddiqschjgc.supabase.co/storage/v1/object/public/images/${meta.images[i]}">
						<img class="clickableimage" loading="lazy" src="https://mfszvmepvrddiqschjgc.supabase.co/storage/v1/object/public/images/${meta.images[i]}">
					</a>
				</div>`;

			}

			images += '</div>';

		}

		if(!meta.location) meta.location = 'here';
		if(!meta.message) meta.message = '';

		let updatehtml = '';

		if(hasImages){
			updatehtml = updatephototemplate.interpolate({ moment: moment(created_at), location: meta.location, message: meta.message });
		}else{
			updatehtml = updatetemplate.interpolate({ moment: moment(created_at), location: meta.location, message: meta.message });
		}

		updatehtml = updatehtml.replace('[IMAGES]', images);

		let update = document.createElement('div');
		update.className = "location-marker update";
		update.innerHTML = updatehtml;


		// const infowindow = new google.maps.InfoWindow({
		// 	content: contentString,
		// });

		// const marker = new google.maps.Marker({
		// 	position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
		// 	icon: {
		// 		path: google.maps.SymbolPath.CIRCLE,
		// 		scale: 10,
		// 		strokeColor: "#79D0E3",
		// 		zIndex:1
		// 	},
		// 	map: this.map,
		// });

		const marker = new AdvancedMarkerElement({
			position: new google.maps.LatLng(parseFloat(lat), parseFloat(lng)),
			map: this.map,
			content: update,
			zIndex: 100,
			// collisionBehavior: 'OPTIONAL_AND_HIDES_LOWER_PRIORITY'
		});

		var lightbox = false;

		if(hasImages){

			lightbox = new SimpleLightbox(update.querySelectorAll('a'));

		}

		google.maps.event.addListener(marker, 'click', (e) => {
			var marker = e.domEvent.target.closest('.location-marker');
			
			if(e.domEvent.target.classList.contains('clickableimage') && lightbox){
				lightbox.open();
			}

			marker.classList.toggle('expanded');

		});

	}

	checkForNewPoints(){

		console.log('checking for new points');

		const dateStart = new Date(this.latest);
		dateStart.setSeconds(dateStart.getSeconds() + 1);

		this.supabase
			.from('location')
			.select('user,longitude,latitude,meta,created_at')
			.gt('created_at', dateStart.toISOString())
			.order('created_at')
			.then(({data, error}) => {

				if(error){
					console.log('No data could be found', error);
				}else if(data.length > 0){

					for(var i = 0; i < data.length; i++){

						if('update' in data[i].meta){

							this.addUpdateMarker(data[i].latitude, data[i].longitude, data[i].meta, data[i].created_at);

						}else{

							if(data[i].meta.type == null || data[i].meta.type == 'null' || !data[i].meta.type){
								data[i].meta.type = 'Bike1';
							}

							if(data[i].meta.message == null || data[i].meta.message == 'null' || !data[i].meta.message){
								data[i].meta.message = '';
							}

							data[i].heading = 'east';

							if(parseInt(data[i].meta.heading) > 180){
								data[i].heading = 'west';
							}

							if(!(data[i].user in this.paths) && !['BottleCan', 'Van1', 'Van2'].includes(data[i].meta.type)){

								let pathStroke = '#79D0E3';

								if(data[i].meta.type == 'Bike1'){
									pathStroke = '#E0912A';
								}else if(data[i].meta.type == 'Bike2'){
									pathStroke = '#80C587';
								}

								new google.maps.Polyline({
									map: this.map,
									geodesic: true,
									strokeColor: pathStroke,
									strokeWeight: 5
								});

							}

							if(!['BottleCan', 'Van1', 'Van2'].includes(data[i].meta.type)){
								this.paths[data[i].user].getPath().push(new google.maps.LatLng(parseFloat(data[i].latitude), parseFloat(data[i].longitude)))
							}

							let markertemplate = document.getElementById('live-map-marker') ? document.getElementById('live-map-marker').innerHTML : false;

							if(this.markerexpanded[data[i].user]){
								this.markercontents[data[i].user].classList.add('expanded');
							}

							let timer = moment(data[i].created_at);
							let fiveminutes = moment().subtract(5, 'minutes').toDate().getTime();
							// let fifteenminutes = timer.subtract(15, 'minutes').toDate().getTime();
							let time, timeclass = '';

							if(timer.toDate().getTime() > fiveminutes){
								time = 'LIVE'
								timeclass ='time-live'
							}else{
								time = moment(data[i].created_at).fromNow();
								timeclass ='time-notlive'
							}

							this.markercontents[data[i].user].innerHTML = markertemplate.interpolate({ marker: data[i], icons: this.vehicleIcons, time, timeclass });

							this.markers[data[i].user].content = this.markercontents[data[i].user];
							this.markers[data[i].user].position = new google.maps.LatLng(parseFloat(data[i].latitude), parseFloat(data[i].longitude));

						}
					}

					// console.log('latest date', data[data.length-1].created_at);

					this.latest = data[data.length-1].created_at;

					if(!this.scrolled){
						// this.map.setCenter({ lat: parseFloat(data[data.length-1].latitude), lng: parseFloat(data[data.length-1].longitude) });
					}

				}

			});

		let time15minutesago = moment().subtract(60, 'minutes').toDate().getTime();
		let timelast = moment(this.latest).toDate().getTime();

		if(timelast < time15minutesago){

			console.log('finished called');

			if(this.finished.redirect.length > 0) {

				if (!Shopify.designMode) {
					window.location.href = this.finished.redirect;
				}

			}else{

				let finishedtemplate = document.getElementById('live-map-finished') ? document.getElementById('live-map-finished').innerHTML : false;

				console.log(finishedtemplate);

				this.classList.add('finished')
				let message = this.querySelector('#message')

				if(!message){
					message = document.createElement('div');
					message.id = 'message';
					this.prepend(message);
				}

				message.innerHTML = finishedtemplate.interpolate({ finished: this.finished });

				message.querySelector('.close').addEventListener('click', (e) => {
					e.preventDefault();
					this.classList.add('finished-closed')
				})

			}

		}

	}

	zoomToFit(){

		if(!this.scrolled){

			var bounds = new google.maps.LatLngBounds();

			for (const user in this.markers){

				bounds.extend(this.markers[user].position);

			}

			let padding = 20;

			if(window.innerWidth > 600) {

				padding = 100;

			}

			console.log(padding);

			this.map.fitBounds(bounds, padding);

		}else{

			clearInterval(this.zoominterval);

		}

	}

	createToggleStoresControl() {

		this.controlButton = document.createElement("button");

		// Set CSS for the control.

		this.controlButton.style.background = "none padding-box rgb(255, 255, 255)";
		this.controlButton.style.border = "0px";
		this.controlButton.style.borderRadius = "2px";
		this.controlButton.style.boxShadow = "rgba(0, 0, 0, 0.3) 0px 1px 4px -1px";
		this.controlButton.style.color = "rgb(86, 86, 86)";
		this.controlButton.style.cursor = "pointer";
		this.controlButton.style.fontFamily = "Roboto,Arial,sans-serif";
		this.controlButton.style.fontSize = "18px";
		// this.controlButton.style.lineHeight = "38px";
		this.controlButton.style.margin = "10px 0 0 10px";
		this.controlButton.style.padding = "10px 13px";
		this.controlButton.style.textAlign = "center";
		this.controlButton.style.textTransform = "none";
		this.controlButton.textContent = "Show stockists";
		this.controlButton.type = "button";
		// Setup the click event listeners: simply set the map to Chicago.
		this.controlButton.addEventListener("click", () => {
			console.log('toggleStores')
			this.toggleStores();
		});

		// Create the DIV to hold the control.
		this.centerControlDiv = document.createElement("div");

		// Append the control to the DIV.
		this.centerControlDiv.appendChild(this.controlButton);
		this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(this.centerControlDiv);

	}

	toggleStores(){
		console.log('toggleStores called')
		this.storeMarkersVisible = !this.storeMarkersVisible;
		this.controlButton.textContent = this.storeMarkersVisible ? "Hide stockists" : "Show stockists" ;
		for(let i = 0; i < this.storeMarkers.length; i++){
			this.storeMarkers[i].setVisible(this.storeMarkersVisible);
		}
		this.storeClusterer.render();
	}

	async loadStores(){

		console.log('loadingStores');

		const infoWindow = new google.maps.InfoWindow({
			content: "",
			disableAutoPan: true,
		});

		this.supabase
			.from('store')
			.select('store_type,store_longitude,store_latitude,store_address')
			.limit(5000)
			.then(({data, error}) => {

				if(error){

					console.log('No data could be found', error);

				}else{

					console.log('running stores');
					
					this.storeMarkers = data.map((store) => {

						console.log('store');

						//const label = labels[i % labels.length];
						const marker = new google.maps.Marker({
							position: { lat: parseFloat(store.store_latitude), lng: parseFloat(store.store_longitude) },
							title: store.store_address,
							icon: {
								url: this.storeIcons[store.store_type.replace(/[^a-z]/gi, '').toLowerCase()],
								// This marker is 20 pixels wide by 32 pixels high.
								size: new google.maps.Size(128, 128),
								scaledSize: new google.maps.Size(35, 35),
								// The origin for this image is (0, 0).
								origin: new google.maps.Point(0, 0),
								// The anchor for this image is the base of the flagpole at (0, 32).
								anchor: new google.maps.Point(0, 20),
							}
						});

						// console.log('smv', this.storeMarkersVisible);
						marker.setVisible(this.storeMarkersVisible);

						// markers can only be keyboard focusable when they have click listeners
						// open info window when marker is clicked
						marker.addListener("click", () => {
							infoWindow.setContent(marker.title);
							infoWindow.open(this.map, marker);
						});

						return marker;

					});

					var algorithm = new GridAlgorithm({
						maxZoom: 21
					})

					var _this = this;

					class DefaultRenderer {

						render({ count, position }) {

								// create svg url with fill color
								const svg = window.btoa(`
									<svg fill="#64C5E3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
										<circle cx="120" cy="120" opacity="1" r="70" />
										<circle cx="120" cy="120" opacity=".3" r="90" />
										<circle cx="120" cy="120" opacity=".2" r="110" />
									</svg>`);
								// create marker using svg icon
								const marker = new google.maps.Marker({
										position,
										icon: {
												url: `data:image/svg+xml;base64,${svg}`,
												scaledSize: new google.maps.Size(45, 45),
										},
										label: {
												text: String(count),
												color: "rgba(255,255,255,0.9)",
												fontSize: "12px",
										},
										title: `Cluster of ${count} markers`,
										// adjust zIndex to be above other markers
										// zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
								});

								marker.setVisible(_this.storeMarkersVisible);

								return marker;
				
						}

					}

					var blueRenderer = new DefaultRenderer();


					// Add a marker clusterer to manage the markers.
					this.storeClusterer = new MarkerClusterer({
						map: this.map,
						markers: this.storeMarkers,
						algorithm,
						renderer: blueRenderer
					});

					this.createToggleStoresControl();

				}

			});

	}


}

customElements.define('live-map', LiveMap);
